import React from "react";
import { Fade } from "react-awesome-reveal";
import "../styles/Promo.scss";

export const Promo = () => {
  return (
    <div className="promoContainerMain d-flex justify-content-center align-items-center">
      <div className="row promoContainer d-flex justify-content-center align-items-center">
        <div className="textPromo col-md-7 d-flex justify-content-center align-items-center flex-column">
          <Fade>
            <span className="textPromoFirst">
              💼 Inicia tu carrera con Asesorarte en Seguros 🌟<br />
              Recibe capacitación, mentoría y apoyo para construir tu propio negocio y alcanzar ingresos sin límite. <br />
            </span>
          </Fade>
        </div>
      </div>
    </div>
  );
};

export default Promo;
